import * as React from 'react';
import S from 's-js';
import { SuperCriticalComponent, SuperCriticalReference } from 'lib/supercritical';
import { Login } from './model';
import * as $ from 'jquery';
import { noDefault } from 'lib/eventWrappers';
import { PCModal } from 'portcall/pcmodal/view';

interface LoginViewProps {
    modelContainer : () => Login | null, 
    domainUses2FA? : boolean;
}

export class LoginView extends SuperCriticalComponent<LoginViewProps> {
    userNameRef : (e : HTMLInputElement | null) => void;

    constructor(props : LoginViewProps) {
        super(props);
        this.userNameRef = SuperCriticalReference(this, (props : LoginViewProps, el : HTMLInputElement) => {
            // focus username input when modal opens
            let $modal = $(el).closest('.modal'),
                focus = () => el.focus();

            $modal.on('shown.bs.modal', focus);
            S.cleanup(() => $modal.off('shown.bs.modal', focus));
        });
    }

    srender({ modelContainer, domainUses2FA } : LoginViewProps) : React.ReactElement<any> {
        return (
            <PCModal className="login" shown={() => !!modelContainer()} onBackDropClick={modelContainer()?.HidePopup}>
                <div className="modal-content">
                    <div className="modal-header">
                        {(m => m &&
                            <button className="close" onClick={m.HidePopup}>
                                <span className="pc-close-icon" aria-hidden="true"></span>
                                <span className="sr-only">Close</span>
                            </button>
                        )(modelContainer())}
                        <h2 className="modal-title">Log in</h2>
                    </div>
                    {(m => m && domainUses2FA &&
                        <div className="modal-body">
                            {m.LoginError() &&
                                <div className="alert alert-danger">
                                    Incorrect Email or Password. Please try again.
                                </div>
                            }
                            {m.TwoFAEmailError() && 
                                <div className="alert alert-danger">
                                    That email is not in the system. Please try again.
                                </div>
                            }
                            {m.TwoFACodeError() && 
                                <div className="alert alert-danger">
                                    That authentication code is incorrect. Please see your email.
                                </div>
                            }
                            {m.twoFAEncryptedValue() == '0' ? 
                                <form onSubmit={noDefault(m.Check2FAEmail)}>
                                    <div className="form-group">
                                        <input className="form-control username"
                                            placeholder="Email"
                                            value={m.TwoFAEmailRequest.Email()}
                                            onChange={e => m.TwoFAEmailRequest.Email((e.target as HTMLInputElement).value)}
                                            ref={this.userNameRef}/>
                                    </div>
                                    <div className="form-group">
                                        <button type="submit" className="pc-button login-button">Login</button>
                                    </div>
                                    <div className="form-group forgotPassword">&nbsp;</div>
                                </form> 
                            : 
                                !m.hasTwoFA() ?
                                    <form onSubmit={noDefault(m.Check2FACode)}>
                                        <div className="two-fa">
                                            Enter the 6-digit code from your verification email.
                                        </div>
                                        <div className="form-group">
                                            <input className="form-control username"
                                                placeholder="Access Code"
                                                value={m.twoFAUserValue()}
                                                onChange={e => m.twoFAUserValue((e.target as HTMLInputElement).value)} />
                                        </div>
                                        <div className="form-group">
                                            <button type="submit" className="pc-button login-button">Verify</button>
                                        </div>
                                    <div className="form-group forgotPassword">&nbsp;</div>
                                    </form>
                                :
                                    <form onSubmit={noDefault(m.Login)}>
                                        <div className="form-group">
                                            <input className="form-control username"
                                                placeholder="Username"
                                                value={m.LoginRequest.UserName()}
                                                onChange={e => m.LoginRequest.UserName((e.target as HTMLInputElement).value)}
                                                ref={this.userNameRef}/>
                                        </div>
                                        <div className="form-group">
                                            <input type="password" className="form-control password"
                                                placeholder="Password"
                                                value={m.LoginRequest.Password()}
                                                onChange={e => m.LoginRequest.Password((e.target as HTMLInputElement).value)} />
                                        </div>
                                        <div className="form-group">
                                            <button type="submit" className="pc-button login-button">Login</button>
                                        </div>
                                        <div className="form-group forgotPassword">
                                            <a href="" className="forgot-password" onClick={noDefault(m.ForgotPassword)}>Forgot Password?</a>
                                        </div>
                                    </form>
                            }
                        </div>
                    )(modelContainer())}
                    {(m => m && !domainUses2FA &&
                        <div className="modal-body">
                            {m.LoginError() &&
                                <div className="alert alert-danger">
                                        Incorrect Email or Password. Please try again.
                                </div>
                            }
                            <form onSubmit={noDefault(m.Login)}>
                                <div className="form-group">
                                    <input className="form-control username"
                                        placeholder="Username"
                                        value={m.LoginRequest.UserName()}
                                        onChange={e => m.LoginRequest.UserName((e.target as HTMLInputElement).value)}
                                        ref={this.userNameRef}/>
                                </div>
                                <div className="form-group">
                                    <input type="password" className="form-control password"
                                        placeholder="Password"
                                        value={m.LoginRequest.Password()}
                                        onChange={e => m.LoginRequest.Password((e.target as HTMLInputElement).value)} />
                                </div>
                                <div className="form-group">
                                    <button type="submit" className="pc-button login-button">Login</button>
                                </div>
                                <div className="form-group forgotPassword">
                                    <a href="" className="forgot-password" onClick={noDefault(m.ForgotPassword)}>Forgot Password?</a>
                                </div>
                            </form>
                        </div>
                    )(modelContainer())}
                </div>
            </PCModal>
        );
    }
}



// WEBPACK FOOTER //
// ./apps/portcall/login/view.tsx